export default __webpack_public_path__ + "static/ml-logo-b8f1af640bf6a56ab4464f1394574e60.svg";